module.exports = __webpack_public_path__ + "static/media/green-checked.6e5e5bc6.svg";